/**
 * Legacy crypto facade. Delegates to chassis/crypto. Kept for back-compat with
 * scripts/smoke_test.ts and the existing encrypted blob at /data.encrypted.json.
 * All NEW code should import from './chassis/crypto.ts' (or barrel chassis).
 */
import { decryptJSON as _decrypt, encryptJSON as _encrypt } from './chassis/crypto.ts';
import type { CiphertextB64, Passcode } from './chassis/branded.ts';

export async function encryptJSON(passcode: string, data: unknown): Promise<string> {
  return _encrypt(passcode as Passcode, data, 1);
}

export async function decryptJSON<T>(passcode: string, blob: string): Promise<T> {
  return _decrypt<T>(passcode as Passcode, blob as CiphertextB64);
}
